import pkgJSON from "../../package.json"

export const PROJECT_BUILD_VERSION = pkgJSON.version;
export const API_URL = window.CONFIG.REACT_APP_API_URL;
export const AUTH_API_URL = window.CONFIG.REACT_APP_AUTH_API_URL;
export const BARS_DOWNLOAD_URLS = window.CONFIG.BARS_DOWNLOAD_URLS

// formats
export const DATE_FORMAT = "DD/MM/YY"
export const DATE_FORMAT_YEAR = "DD/MM/YYYY"
export const DATETIME_FORMAT_FULL = "DD/MM/YYYY HH:mm:ss"
export const DATETIME_FORMAT = DATE_FORMAT + " HH:mm:ss"
export const DATETIME_FORMAT_MS = DATETIME_FORMAT + ".SSS"
// auth
export const INACTIVE_AUTHORIZED_TIME = 10 * 60 * 1000